import { useEffect, useState } from "react";

import { ISocketService } from "./socket-service";

let current: ISocketService | null = null;
const listeners = new Set<(s: ISocketService | null) => void>();

export const setGlobalSocket = (socket: ISocketService | null): void => {
  current = socket;
  listeners.forEach((l) => l(socket));
};

export const getGlobalSocket = (): ISocketService | null => current;

export const useGlobalSocket = (): ISocketService | null => {
  const [socket, setSocket] = useState<ISocketService | null>(current);

  useEffect(() => {
    listeners.add(setSocket);
    setSocket(current);
    return () => {
      listeners.delete(setSocket);
    };
  }, []);

  return socket;
};
